import React, { useState } from "react";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
// import "./public/css/SideNavigation.scss";

const SideNavigation = ({ selected, menus, updateMenu, keepExpanded }) => {
  const [expanded, setExpanded] = useState(keepExpanded ? true : false);
  const extractFAIconName = (text) => {
    // This will match the last "fa-something" in the string
    const match = text.match(/fa-[a-z0-9-]+$/);
    return match ? match[0] : null;
  }
  return (
    <SideNav className="left-menu" onBlur={() => expanded && setExpanded(false)} onSelect={(i) => updateMenu?.({ selected: i })} onToggle={(i) => setExpanded(i)} expanded={expanded}>
      {keepExpanded ? null : <SideNav.Toggle />}
      <SideNav.Nav selected={selected}>
        {menus && menus.length > 0 ? (
          menus.map((menuitem, index) => {
            return (
              <NavItem
                eventKey={menuitem}
                key={index}
                onClick={(i) => (menuitem.submenu ? this.menuSelect({ selected: menuitem.submenu[0] }) : null)}
                title={menuitem.name}
              >
                <NavIcon>
                  {/* <abbr title={menuitem.name} style={{ cursor: "pointer" }}> */}
                  <i className={"fa-regular " + extractFAIconName(menuitem.icon)} name={menuitem.name} style={{ fontSize: "1.5em", verticalAlign: "middle", cursor: "pointer" }} />
                  {/* </abbr> */}
                </NavIcon>
                <NavText
                  style={{ paddingRight: 32 }}
                  name={menuitem.name}
                  // title={menuitem.name}
                >
                  {menuitem.name.length > 18 ? menuitem.name.substring(0, 18) + "..." : menuitem.name}
                </NavText>
                {menuitem.submenu
                  ? menuitem.submenu.map((subMenu, index2) => {
                      return (
                        <NavItem eventKey={subMenu} key={`${Math.random()}_${Math.random()}`} expanded={true} title={subMenu.name}>
                          <NavIcon>
                            {/* <abbr
                          title={subMenu.name}
                          style={{ cursor: "pointer" }}
                        > */}
                            <i
                              className={subMenu.icon}
                              name={subMenu.name}
                              style={{
                                fontSize: "1.5em",
                                verticalAlign: "middle",
                                cursor: "pointer",
                              }}
                            />
                            {/* </abbr> */}
                          </NavIcon>
                          <NavText
                            style={{ paddingRight: 32 }}
                            name={subMenu.name}
                            // title={subMenu.name}
                          >
                            {subMenu.name.length > 18 ? subMenu.name.substring(0, 18) + "..." : subMenu.name}
                          </NavText>
                        </NavItem>
                      );
                    })
                  : null}
              </NavItem>
            );
          })
        ) : (
          <div></div>
        )}
      </SideNav.Nav>
    </SideNav>
  );
};

export default SideNavigation;
